module.exports = __webpack_public_path__ + "frontend/images/languages/is@2x.png?858f4382b19831c8f4e1c7cb3c941029";